import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from '../../../components/FbUI/Page/styles'
import { RemindersTableProvider } from 'components/Reminders/RemindersTable'

export function RemindersPage() {
  return (
    <FBPage>
      <FBPageHeader>
        <FBPageTitleRow>
          <FBPageTitle>Reminders</FBPageTitle>
        </FBPageTitleRow>
      </FBPageHeader>

      <FBPageTableContainer>
        <RemindersTableProvider tableKey={'reminders-table'} />
      </FBPageTableContainer>
    </FBPage>
  )
}
